module.exports = __webpack_public_path__ + "static/media/search-active-icon.97cd65c4.svg";